import * as React from "react";
import TextField from "@mui/material/TextField";

export function IntegerEditCell(params) {
  const { id, field, api, value } = params;
  const [val, setVal] = React.useState(value ?? "");

  const onChange = (e) => {
    const raw = e.target.value;
    // allow empty, else digits only
    const next = raw === "" ? "" : raw.replace(/\D+/g, "");
    setVal(next);
  };

  // const commit = async (e) => {
  //   const numeric = val === "" ? null : Number(val);
  //   const ok = await api.setEditCellValue({ id, field, value: numeric }, e);
  //   if (ok) api.stopCellEditMode({ id, field });
  // };

  const commit = async (e) => {
    const numeric = val === "" ? null : Number(val);

    await api.setEditCellValue({ id, field, value: numeric, debounceMs: 0 }, e);

    // 🟢 Only stop edit mode if still in edit mode
    if (api.getCellMode(id, field) === "edit") {
      api.stopCellEditMode({ id, field });
    }
  };


  const onKeyDown = (e) => {
    if (e.key === "Enter"  || e.key === "Tab") {
      e.preventDefault();
      commit(e);
    }
  };

  return (
    <TextField
      autoFocus
      fullWidth
      size="small"
      type="text" // no spinners
      inputMode="numeric" // mobile numeric keyboard
      value={val === 0 ? "" : val ?? ""}
      onChange={onChange}
      onBlur={commit}
      onKeyDown={onKeyDown}
    />
  );
}

export function DecimalEditCell(params) {
  const { id, field, api, value } = params;
  const [val, setVal] = React.useState(value ?? "");

  const onChange = (e) => {
    const raw = e.target.value;
    // allow empty, digits, and a single dot
    const next =
      raw === "" ? "" : raw.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");
    setVal(next);
  };

  const commit = async (e) => {
  const numeric = val === "" ? null : Number(val);

  await api.setEditCellValue(
    { id, field, value: numeric, debounceMs: 0 },
    e
  );

  // 🟢 Only stop edit mode if still in edit mode
  if (api.getCellMode(id, field) === "edit") {
    api.stopCellEditMode({ id, field });
  }
};


  const onKeyDown = (e) => {
    if (e.key === "Enter"  || e.key === "Tab") {
      e.preventDefault();
      commit(e);
    }
  };

  return (
    <TextField
      autoFocus
      fullWidth
      size="small"
      type="text" // no spinners
      inputMode="decimal" // mobile decimal keyboard
      value={val === 0 ? "" : val ?? ""}
      onChange={onChange}
      onBlur={commit}
      onKeyDown={onKeyDown}
    />
  );
}
